import { DotState } from './gobjects/Dot';
export { Background } from './gobjects/Background';
export { Dot } from './gobjects/Dot';
export { Rectangle } from './gobjects/Rectangle';
export let states = {
    DotState
};
//# sourceMappingURL=GObjects.js.map